import { ArrowDown, CalendarPlus, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&w=800&q=80";

export const HeroSection = () => {
  const handleProbarAsistente = () => {
    window.dispatchEvent(new CustomEvent("open-chat"));
  };

  const handlePedirCita = () => {
    window.dispatchEvent(
      new CustomEvent("open-chat", { detail: { message: "Quiero pedir cita" } })
    );
  };

  return (
    <section
      data-testid="hero-section"
      className="relative pt-28 pb-20 md:pt-36 md:pb-32 overflow-hidden"
    >
      {/* Subtle background decoration */}
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-secondary/60 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-muted/60 rounded-full blur-[100px] pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Text side */}
          <div className="max-w-xl">
            <div className="animate-fade-in-up">
              <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary text-secondary-foreground text-sm font-medium mb-3">
                <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
                Asistente 24/7 para dudas frecuentes y solicitudes de cita
              </span>
              <p className="text-xs text-muted-foreground mb-3">
                Para urgencias: llama al centro o acude a un servicio de urgencias veterinarias.
              </p>
            </div>

            <h1
              data-testid="hero-title"
              className="animate-fade-in-up delay-100 text-4xl sm:text-5xl lg:text-[3.4rem] font-bold text-foreground tracking-tight leading-[1.1] mb-6"
            >
              Atención veterinaria cercana,{" "}
              <span className="text-primary">sin esperas innecesarias</span>
            </h1>

            <p
              data-testid="hero-subtitle"
              className="animate-fade-in-up delay-200 text-base md:text-lg text-muted-foreground leading-relaxed mb-10 max-w-md"
            >
              Resolvemos dudas frecuentes, orientamos urgencias y registramos
              solicitudes de cita en minutos.
            </p>

            <div className="animate-fade-in-up delay-300 flex flex-col sm:flex-row gap-4">
              <Button
                data-testid="hero-probar-asistente-btn"
                onClick={handleProbarAsistente}
                className="rounded-full px-8 h-12 text-base font-medium bg-primary text-primary-foreground hover:bg-[#1e3d22] shadow-lg hover:shadow-xl transition-shadow"
              >
                Probar asistente
                <ArrowDown className="w-4 h-4 ml-2" strokeWidth={2} />
              </Button>
              <Button
                data-testid="hero-pedir-cita-btn"
                onClick={handlePedirCita}
                variant="outline"
                className="rounded-full px-8 h-12 text-base font-medium border-2 border-primary/15 text-foreground hover:bg-secondary/60 hover:border-primary/30 transition-colors"
              >
                <CalendarPlus className="w-4 h-4 mr-2" strokeWidth={1.5} />
                Pedir cita
              </Button>
            </div>
          </div>

          {/* Image side */}
          <div className="animate-slide-in-right delay-300 relative">
            <div className="relative rounded-[2rem] overflow-hidden shadow-2xl shadow-primary/10">
              <img
                src={HERO_IMAGE}
                alt="Perro feliz recibiendo cuidado veterinario"
                className="w-full h-[360px] md:h-[460px] object-cover"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent" />
            </div>

            {/* Floating card */}
            <div className="absolute -bottom-4 -left-4 md:bottom-6 md:-left-6 bg-white rounded-2xl p-4 shadow-xl border border-border/30 animate-float">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center">
                  <Clock className="w-5 h-5 text-primary" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground">Cita en 1–2 min</p>
                  <p className="text-xs text-muted-foreground">Solicitud rápida y guiada</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
